module.exports = __webpack_public_path__ + "static/media/payment.a1ce0900.png";